import { render, staticRenderFns } from "./orderComment.vue?vue&type=template&id=4c7042f8&scoped=true&"
import script from "./orderComment.vue?vue&type=script&lang=js&"
export * from "./orderComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7042f8",
  null
  
)

export default component.exports